import { computed, Injectable, Signal } from '@angular/core';
import { PermissionDto, RoleServiceProxy } from '@shared/service-proxies/service-proxies';
import { rxResource } from '@angular/core/rxjs-interop';
import { map, Observable, of } from 'rxjs';
import { PermissionConsts } from '@shared/permission-consts';
import { PermissionCheckerService } from 'abp-ng2-module';
import { resourceSuccess } from '@shared/helpers/rx-utils';
import { AppSessionService } from '@shared/session/app-session.service';

@Injectable({ providedIn: 'root' })
export class PermissionsValueStore {
    resCompleted = computed(() => {
        return resourceSuccess(this._permissionsRes);
    });
    private _permissionsRes = rxResource({
        // the catalog needs a login and every component injects this store, login page included; login reloads the page
        loader: () => (this.appSession.userId ? this.roleServiceProxy.getAllPermissions().pipe(map(({ items }) => items)) : of([])),
    });

    constructor(
        private permissionChecker: PermissionCheckerService,
        private roleServiceProxy: RoleServiceProxy,
        private appSession: AppSessionService,
    ) {}

    get permissions(): Signal<PermissionDto[]> {
        return this._permissionsRes.value.asReadonly();
    }

    isGranted(permission: string | string[]): boolean {
        if (Array.isArray(permission)) {
            return permission.some((p) => this.permissionChecker.isGranted(p));
        } else {
            return this.permissionChecker.isGranted(permission);
        }
    }

    getParentOrDefault(permission: PermissionConsts): string {
        const permissionName = permission.toString();
        const result = this.permissions().find(({ name }) => name === permissionName);
        return result?.parent ? result?.parent?.name : permissionName;
    }

    grantedOrDefault<T>(permission: PermissionConsts | PermissionConsts[], callback: () => Observable<T>, defaultValue: T = null): Observable<T> {
        if (this.isGranted(permission)) {
            return callback();
        } else {
            return of(defaultValue);
        }
    }
}
